import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/** PD-17623 — what can be logged about a LinkedIn touch with one click. */
export const LINKEDIN_TOUCH_KINDS = ['connection_sent', 'message_sent', 'accepted', 'replied'] as const;
export type LinkedInTouchKind = (typeof LINKEDIN_TOUCH_KINDS)[number];

export const LINKEDIN_TOUCH_LABELS: Readonly<Record<LinkedInTouchKind, string>> = {
	connection_sent: 'Connection sent',
	message_sent: 'Message sent',
	accepted: 'Accepted',
	replied: 'Replied',
};

/**
 * PD-17623 — a LinkedIn touch logged by hand (LinkedIn's API is not used;
 * automatic capture is the browser extension, PD-17576). One row per click,
 * on the person, with the campaign run it belonged to when there was one, so
 * the person's and the account's activity show it wherever it was logged.
 */
@Index('linkedin_touch__contact', ['fkContactId', 'touchedAt'], {})
@Entity('linkedin_touch', {}, { auditable: true })
export class LinkedInTouchEntity extends BaseEntity {
	@Column('int', { name: 'fk_contact__id', unsigned: true })
	public fkContactId!: number;

	@Column('int', { name: 'fk_campaign_membership__id', unsigned: true, nullable: true })
	public fkCampaignMembershipId!: number | null;

	// App-validated (LinkedInTouchKind).
	@Column('varchar', { name: 'kind', length: 30 })
	public kind!: LinkedInTouchKind | string;

	@Column('text', { name: 'note', nullable: true })
	public note!: string | null;

	@Column('datetime', { name: 'touchedAt' })
	public touchedAt!: Date;

	/** Tenant user id of who logged it. */
	@Column('int', { name: 'fk_user__id', unsigned: true, nullable: true })
	public fkUserId!: number | null;
}
